import React from "react";
import '../css/home-hero-banner.css';
import '../css/main.css';

export default function HomeHeroBanner() {
    return (
        <section id="home-first-look">
            <img src="images/Main logo - no background.png"></img>
        </section>
    )
};